
export enum userRole{
    Admin="ADMIN",
    USER="USER",
    BA="BA"
}

export enum appTypeValue{
    ECC="ECC",
    BW="BW",
    APO="APO",
    SRM="SRM",
    S4HANA="HANA"
}

